var map = {
	"./Group 27092.svg": 2042,
	"./Group 27100.svg": 2043,
	"./Group 27102.svg": 2044,
	"./Group 27103.svg": 2045,
	"./Group 27104.svg": 2046,
	"./Group 27105.svg": 2047,
	"./template1.svg": 607,
	"./template10.svg": 935,
	"./template11.svg": 936,
	"./template12.svg": 937,
	"./template13.svg": 938,
	"./template14.svg": 939,
	"./template15.svg": 940,
	"./template16.svg": 941,
	"./template17.svg": 942,
	"./template18.svg": 943,
	"./template2.svg": 944,
	"./template3.svg": 945,
	"./template4.svg": 946,
	"./template5.svg": 947,
	"./template6.svg": 948,
	"./template7.svg": 949,
	"./template8.svg": 950,
	"./template9.svg": 951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2041;